import { Accordion, BasicCollapsible, BoundedContent, Box, H2, Link } from '@vp/swan';
import { __url } from '@99designs/i18n';
import { FormattedReactMessage, __ } from '@99designs/i18n';

export function FAQ() {
    return (
        <BoundedContent paddingTop="8" paddingBottom="8" data-testid="faq">
            <Box paddingLeft={{ xs: 3, md: 0, lg: 12 }} paddingRight={{ xs: 3, md: 0, lg: 12 }}>
                <H2 textAlign="center" data-testid="faq-title">
                    {__('Frequently asked questions')}
                </H2>
                <Accordion single data-testid="faq-accordion">
                    <BasicCollapsible
                        collapsibleId="what-is-a-revision"
                        heading={__('What is a revision?')}
                        headingLevel="h2"
                        data-testid="faq-item-what-is-a-revision"
                    >
                        {__(
                            'A revision is feedback provided to the designer based on the initial design concept they provide. Revisions are changes to an existing concept and not a complete change of direction or a new design.'
                        )}
                    </BasicCollapsible>
                    <BasicCollapsible
                        collapsibleId="how-do-i-review-my-design-services-request"
                        heading={__('How do I review my Design Services request?')}
                        headingLevel="h2"
                        data-testid="faq-item-review-design-services-request"
                    >
                        {__(
                            'You will receive an email notification that your design is ready for review online.'
                        )}{' '}
                        <FormattedReactMessage
                            message={__(
                                'You can access your project and view your designs at any time from your <Link>My Design Services</Link> dashboard.'
                            )}
                            replacements={{
                                Link: (
                                    <Link
                                        href={__url('/graphic-design/dashboard')}
                                        target="_blank"
                                    />
                                ),
                            }}
                        />
                    </BasicCollapsible>
                    <BasicCollapsible
                        collapsibleId="what-if-im-not-happy-with-my-design"
                        heading={__('What if I’m not happy with my design?')}
                        headingLevel="h2"
                        data-testid="faq-item-not-happy-with-design"
                    >
                        {__(
                            'Every design detail matters – to you and to us. Our Satisfaction Guarantee means that if you have any questions or concerns with your order, we can help. Our experts are available by phone, email or online live chat.'
                        )}{' '}
                        <Link
                            to={__url('/customer-promise')}
                            aria-label={__('Learn more about our customer promise')}
                        >
                            {__('Learn more here.')}
                        </Link>
                    </BasicCollapsible>
                </Accordion>
            </Box>
        </BoundedContent>
    );
}
